import * as LocalStorage from '../lib/LocalStorage';
import { API } from 'aws-amplify';

/** Our client side api that calls AWS Lambda */

// TODO: Refactor refreshTokenAsync and fetchTokenAsyn only difference is body pull out guts into one function
export async function refreshTokenAsync(refreshToken: string) {
  let apiName = 'spotify';
  let path = '/spotify/token';
  let options = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: {
      refreshToken,
    },
  };
  try {
    const response = await API.post(apiName, path, options);
    if (response.status >= 400) {
      throw new Error(response.error);
    } else {
      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
}

export async function fetchTokenAsync(code: string, redirectUri: string) {
  let apiName = 'spotify';
  let path = '/spotify/token';
  let options = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: {
      code,
      redirectUri,
    },
  };
  try {
    const response = await API.post(apiName, path, options);
    if (response.status >= 400) {
      throw new Error(response.error);
    } else {
      return response;
    }
  } catch (error) {
    throw new Error(error);
  }
}

/* 
======== UTIL FUNCTIONS SUPPORTING THE API ============
*/
// Handle refreshing token whenever it's coming due
export async function getValidTokenAsync() {
  try {
    const credentials = await LocalStorage.getAuthCredentialsAsync();
    let currentToken = credentials.token;
    if (shouldTokenBeRenewed(credentials)) {
      const result = await refreshTokenAsync(credentials.refreshToken);
      const newAuthCredentials = {
        ...credentials,
        ...result,
        lastRefreshed: new Date(),
      };
      await LocalStorage.setAuthCredentialsAsync(newAuthCredentials);
      currentToken = newAuthCredentials.token;
    }
    return currentToken;
  } catch (error) {
    throw error;
  }
}

function shouldTokenBeRenewed(credentials) {
  const today = new Date();
  const isTokenExpiringIn10Minutes =
    credentials.expirationTime &&
    today.getTime() > credentials.expirationTime - 600000;
  return isTokenExpiringIn10Minutes;
}
